<template>
  <v-card class="pa-0 ma-0 mt-9 pa-8">
    <v-card-title class="h6 blue-grey--text text--darken-2 ma-0 pa-0 mb-8">
      {{ $t('boards.confirm_the_board') }}</v-card-title
    >
    <v-card-text class="ma-0 pa-0">
      <div class="d-flex mb-2 blue-grey--text text--darken-3 ">
        <p class="ma-0 pa-0 me-3 font-weight-500">
          {{ $t('boards.board_name') }}
        </p>
        <p class="ma-0 pa-0">{{ board.name }}</p>
      </div>
      <p v-if="board.description" class="blue-grey--text text--darken-1 body-2">
        {{ board.description }}
      </p>
      <v-divider class="my-6" />
      <p class="ma-0 pa-0 mb-3 subtitle-2 blue-grey--text text--darken-3">
        {{ $t('boards.column_other') }}:
      </p>
      <div
        v-for="(col, index) in columns"
        class="d-flex mb-4"
        :key="`${col.name}-${index}`"
      >
        <v-icon size="16" color="blue">mdi-table-column</v-icon>
        <p class="ma-0 pa-0 blue-grey--text text--darken-3 caption">
          {{ col.name }}
        </p>
      </div>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0 mt-4 justify-space-between">
      <v-btn
        text
        plain
        rounded
        dense
        color="blue"
        @click="$emit('back')"
        :disabled="loading"
        >{{ $t('common.button.back') }}</v-btn
      >
      <div>
        <v-btn
          text
          plain
          rounded
          dense
          color="blue-grey darken-1"
          :disabled="loading"
          @click="$emit('cancel')"
          >{{ $t('common.button.cancel') }}</v-btn
        >
        <v-btn
          rounded
          dense
          color="blue"
          class="white--text px-4 ms-3"
          elevation="0"
          :loading="loading"
          :disabled="loading || disableCreateBoard"
          @click="$emit('save')"
          >{{ $t('boards.create_board') }}</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'ConfirmationStep',

  props: {
    board: { type: Object, required: true },
    columns: { type: Array, required: true },
    loading: Boolean,
    disableCreateBoard: Boolean,
  },
}
</script>
